import React,{Component} from 'react';
import './InputSelect.css'
import classnames from 'classnames'
import Select from 'react-select';
import { getTranslate } from 'react-localize-redux';
import {connect} from 'react-redux';

class InputSelect extends Component{
    constructor(){
        super()
        this.state={
            value:{}
        }
    }
    handleSelectLabel = () =>{
    } 
    componentDidMount(){
        // this.props.input.onChange(this.props.value)
        let id = this.props.id;
    }
    render(){
        const {options,id,labelName,translate,placeholder,input:{value,onChange,onBlur} ,meta: { touched, error, warning }}= this.props
        return(
            <div className="input-select " style={{zIndex:id}}>
                <label id={id} htmlFor={labelName} className={classnames("select-label",{"input-has-value-label": value})} >{translate(labelName)}</label>
                <Select
                onFocus={ ()=>{
                         let label = document.getElementById(id);
                         label.classList.add('input-has-value-label') 
                    }
                 } 
                    searchable={true}
                    className={classnames({'error':error && touched})}
                    id={labelName}
                    options={options}
                    name={labelName}
                    placeholder={''}
                    value={value}
                    clearable={false}
                    onChange={s => {
                        const value =
                            s !== null
                                ? Array.isArray(s) ? s.map(o => o.value) : s.value
                                : '';
                        onChange(value);
                        this.handleSelectLabel
                    }}
                    onBlur={() => {
                        onBlur(value);
                        if(!value){
                            let label = document.getElementById(id);
                            label.classList.remove('input-has-value-label')                         
                        }

                    }}
                    openOnFocus={true}
                />
                {touched &&(error && <span className="error-text">{translate(error)} </span>)}
        </div>

        )
    }
}
const mapStateToProps = state => ({
    translate: getTranslate(state.locale),
});
export default  connect(mapStateToProps)(InputSelect)




// WEBPACK FOOTER //
// ./src/components/Input-select/InputSelect.js